import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import pizzaImage from "../images/bartolliniCover.png";

const Home: React.FC = () => {
  return (
    <>
      {/* Hero Section (text left, image right) */}
      <div className="py-5">
        <Container>
          <Row className="align-items-center g-4">
            <Col md={6} className="text-white text-center text-md-start mb-4 mb-md-0">
              <div className="hero-text mx-auto mx-md-0">
                <h1 className="display-4 fw-bold mb-3">Authentic Wood-Fired Pizza</h1>
                <p className="lead mb-4">
                  Book the van for your event — or call in to Ballybrit.
                </p>

                <div className="d-flex gap-2 justify-content-center justify-content-md-start">
                  <Link to="/book-event/" className="btn btn-outline-warning">
                    Book an Event
                  </Link>
                  <Link to="/gallery" className="btn btn-outline-light">
                    View Gallery
                  </Link>
                </div>
              </div>
            </Col>

            <Col md={6} className="text-center">
              <img
                src={pizzaImage}
                alt="Bartollini Pizza"
                className="img-fluid"
                style={{ maxWidth: "80%", height: "auto", marginBottom: 0 }}
              />
            </Col>
          </Row>
        </Container>
      </div>

      {/* Welcome Section */}
      <Container className="text-center text-white py-5">
        <h1 className="fw-bold mb-3">Welcome to Bartollini Pizza</h1>
        <p className="lead mb-5">
          Serving Galway from our permanent location and restored mobile pizza van — available 
          for private events and bookings across Ireland.
        </p>

        <Row className="text-center g-4">
          <Col md={4}>
            <h4 className="mb-2">
              🔥 <span className="fw-semibold">Wood-Fired Perfection</span>
            </h4>
            <p className="mb-0">
              Every pizza is made fresh on-site using traditional methods and cooked in our wood-fired oven
              for that perfect crisp and flavour.
            </p>
          </Col>

          <Col md={4}>
            <h4 className="mb-2">
              🚐 <span className="fw-semibold">Pizza for Your Event</span>
            </h4>
            <p className="mb-0">
              Our pizza vans bring the taste of Italy to birthdays, weddings, and corporate events—wherever you are.
            </p>
          </Col>

          <Col md={4}>
            <h4 className="mb-2">
              📍 <span className="fw-semibold">Galway Location</span>
            </h4>
            <p className="mb-0">
              Visit us in Ballybrit, Galway for dine-in or takeaway
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Home;
